export default {
  directs: 'مکالمه‌ها',
  sendMsg: 'ارسال پیام',
  pleaseSelectAChat: 'لطفاً گفتگویی انتخاب کنید.',
  close: 'بستن',
};
